import { FC, useEffect } from "react";
import "shepherd.js/dist/css/shepherd.css";
import { useSkyViewStore } from "~/features/skyView/store";
import { useOnboardingTour } from "../hooks/useOnboardingTour";
import "../styles/shepherd-custom.css";

export const SkyViewTour: FC = () => {
  const setExpanded = useSkyViewStore((state) => state.setExpanded);
  const { startTour, shouldShowTour } = useOnboardingTour({
    tourType: "skyView",
    enabled: true,
  });

  useEffect(() => {
    if (shouldShowTour()) {
      setExpanded(true);
      const timer = setTimeout(() => {
        startTour();
      }, 800);
      return () => clearTimeout(timer);
    }
  }, [shouldShowTour, startTour, setExpanded]);

  return null;
};
